import axios from 'axios';
import { BASE_URL } from '../api';
import { rememberGuest } from '../drawer/api';
const http = axios.create({ baseURL: BASE_URL, timeout: 20000 });
const root = '/tasks/moonmeet/';
const memory = new Map();
const key = invite => 'lunadesk.moonmeet.session.v1.' + invite;
export function accountToken() { try { return localStorage.getItem('auth_token') || ''; } catch { return ''; } }
export function auth(invite) {
  let session = memory.get(invite); try { session = localStorage.getItem(key(invite)) || session; } catch {}
  const jwt = accountToken();
  return session ? (jwt ? `MoonMeetAccount ${jwt}~${session}` : `MoonMeet ${session}`) : jwt ? `Bearer ${jwt}` : '';
}
export function forget(invite) { memory.delete(invite); try { localStorage.removeItem(key(invite)); } catch {} }
export function device() { try { let value = localStorage.getItem('lunadesk.moonmeet.device.v1'); if (!value) { value = crypto.randomUUID(); localStorage.setItem('lunadesk.moonmeet.device.v1', value); } return value; } catch { return crypto.randomUUID(); } }
export async function request(path, data, method = 'GET', invite) {
  const result = await http.request({ url: root + path, method, data, headers: { Authorization: auth(invite) } });
  return result.data;
}
export const profile = () => request('me/');
export const list = () => request('meetings/');
export const create = data => request('meetings/', data, 'POST');
export const detail = id => request(`meetings/${id}/`);
export const edit = (id, data) => request(`meetings/${id}/`, data, 'PATCH');
export const cancel = id => request(`meetings/${id}/`, undefined, 'DELETE');
export const end = id => request(`meetings/${id}/`, { action: 'end' }, 'POST');
export const extend = (meeting, minutes) => request(`meetings/${meeting.id}/`, { action: 'extend', minutes, expected_expires_at: meeting.expires_at }, 'POST');
export const info = invite => request(`invites/${invite}/`);
export async function join(invite, name) {
  const result = await request(`invites/${invite}/join/`, { name, device: device() }, 'POST', invite);
  if (result.session) { memory.set(invite, result.session); try { localStorage.setItem(key(invite), result.session); } catch {} }
  return result;
}
export const state = session => request(`meetings/${session.meeting.id}/state/`, undefined, 'GET', session.invite);
export const connect = session => request(`meetings/${session.meeting.id}/connect/`, {}, 'POST', session.invite);
export const leave = session => request(`meetings/${session.meeting.id}/leave/`, {}, 'POST', session.invite);
export const control = (session, action) => request(`meetings/${session.meeting.id}/control/`, { action }, 'POST', session.invite);
export const moderate = (session, member, action) => request(`meetings/${session.meeting.id}/members/${member}/`, { action }, 'POST', session.invite);
export const chat = (session, text, client_id) => request(`meetings/${session.meeting.id}/messages/`, { text, client_id }, 'POST', session.invite);
export const removeMessage = (session, id) => request(`meetings/${session.meeting.id}/messages/${id}/`, undefined, 'DELETE', session.invite);
export async function board(session, scope) {
  const value = await request(`meetings/${session.meeting.id}/board/`, scope ? { scope } : {}, 'POST', session.invite);
  // Reuse the existing Drawer capability transport; no credentials in the URL.
  rememberGuest(value.link, value.session);
  return value;
}
export const socket = id => `${BASE_URL.replace(/^http/, 'ws')}/ws/moonmeet/${id}/`;
export function error(error) { const value = error?.response?.data; return typeof value?.detail === 'string' ? value.detail : Array.isArray(value) ? value.join(' ') : error?.message || 'Не удалось выполнить действие.'; }
